import React from "react";
import styles from "./InwardPDF.module.css";

const InwardPDF = ({ data }) => {
  const groupedItems = (data?.inward_items || []).reduce((acc, item) => {
    const key = `${item.item_code}-${item.type}`;
    if (!acc[key]) {
      acc[key] = {
        mainItem: {
          item_code: item.item_code,
          description: item.make_item_desc,
          type: item.type,
          total_qty: 0,
          uom: item.make_item_uom,
          subItems: [],
        },
      };
    }
    acc[key].mainItem.total_qty += item.qty;
    acc[key].mainItem.subItems.push(item);
    return acc;
  }, {});
  const groupedItemsArray = Object.values(groupedItems)
    .map((group) => group.mainItem)
    .sort((a, b) => a.type - b.type);

  const totalInwardQty =
    data.inward_items &&
    data.inward_items?.reduce(
      (acc, item) => acc + (parseFloat(item?.inward_qty) || 0),
      0
    );

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatNumberWithBreaks = (num) => {
    if (!num && num !== 0) return "-";
    return parseFloat(num)
      .toLocaleString("en-IN", {})
      .replace(/,/g, ",\u200B");
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.header}>
        <div className={styles.logoSection}>
          <img
            src="https://bermadimsapi.disctesting.in/uploads/logo/8e08ec4e6348fc2fe1f64ae147db7496.jpeg"
            alt="BERMAD"
            className={styles.logo}
          />
          <div className={styles.companyName}>
            BERMAD INDIA Private Limited.
          </div>
        </div>
        <div className={styles.addressRight}>
          <h2 className={styles.orderTitle}>Inward Details</h2>
          <div>
            <strong>Project Name:</strong> {data?.project?.project_name || "-"}
          </div>
          <div>
            <strong>Project Code:</strong> {data?.project?.project_code || "-"}
          </div>
        </div>
      </div>

      <div className={styles.blueBar}></div>

      <table className={styles.orderHeader}>
        <tbody>
          <tr>
            <th style={{ width: "25%", textAlign: "left" }}>Inward no:</th>
            <th style={{ width: "25%", textAlign: "left" }}>Inward Date:</th>
            <th style={{ width: "25%", textAlign: "left" }}>Invoice no:</th>
            <th style={{ width: "25%", textAlign: "left" }}>SO No:</th>
          </tr>
          <tr>
            <td className={styles.cellWrap} style={{ textAlign: "left" }}>
              {data?.inward_no || "-"}
            </td>
            <td className={styles.cellNowrap} style={{ textAlign: "left" }}>
              {formatDate(data?.createdAt) || "-"}
            </td>
            <td className={styles.cellWrap} style={{ textAlign: "left" }}>
              {data?.invoice?.invoice_no || "-"}
            </td>
            <td className={styles.cellWrap} style={{ textAlign: "left" }}>
              {data?.order?.order_no || "-"}
            </td>
          </tr>
        </tbody>
      </table>

      <table className={styles.termsTable}>
        <tbody>
          <tr>
            <td className={styles.labelCell}>Warehouse</td>
            <td className={styles.colonCell}>:</td>
            <td className={styles.valueCell}>{data?.warehouse?.warehouse_name || "-"}</td>
            <td className={styles.labelCell}>Inward By</td>
            <td className={styles.colonCell}>:</td>
            <td className={styles.valueCell}>
              {data?.createdBy?.first_name && data?.createdBy?.last_name
                ? `${data.createdBy.first_name} ${data.createdBy.last_name}`
                : "-"}
            </td>
          </tr>
          <tr>
            <td className={styles.labelCell}>Status</td>
            <td className={styles.colonCell}>:</td>
            <td className={styles.valueCell}>
              {data?.order?.status?.split("_").join(" ").toUpperCase() || "-"}
            </td>
            <td className={styles.labelCell}>Remark</td>
            <td className={styles.colonCell}>:</td>
            <td className={styles.valueCell}>{data?.remarks || "-"}</td>
          </tr>
        </tbody>
      </table>

      <table className={styles.catalogTable}>
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr No.</th>
            <th style={{ width: "25%" }}>Item Code</th>
            <th style={{ width: "10%" }}>UOM</th>
            <th style={{ width: "10%" }}>Invoice QTY</th>
            <th style={{ width: "10%" }}>Inward QTY</th>
            <th style={{ width: "10%" }}>Shortage QTY</th>
            <th style={{ width: "10%" }}>Provision QTY</th>
            <th style={{ width: "20%" }}>Remark</th>
          </tr>
        </thead>
        <tbody>
          {groupedItemsArray.map((group, index) => {
            const hasDifferentBuyItems = group.subItems.some(
              (item) => item.buy_item_code !== item.item_code
            );

            return (
              <React.Fragment key={`${group.item_code}-${group.type}`}>
                <tr>
                  <td className={styles.textCenter}>{index + 1}</td>
                  <td>
                    <div className={styles.itemDescription}>
                      <div className={styles.itemCode}>
                        {group?.item_code || "N/A"}
                      </div>
                      <div className={styles.itemDesc}>
                        <span>Product Description:</span>
                        <br />
                        {group?.description || "N/A"}
                      </div>
                    </div>
                  </td>
                  <td className={styles.textCenter}>{group.uom || "N/A"}</td>
                  <td className={styles.textRight}>
                    <div className={styles.numberWrapper}>
                      {hasDifferentBuyItems
                        ? "-"
                        : formatNumberWithBreaks(
                            group.subItems[0]?.remaining_qty
                          ) || "0"}
                    </div>
                  </td>
                  <td className={styles.textRight}>
                    <div className={styles.numberWrapper}>
                      {hasDifferentBuyItems
                        ? "-"
                        : formatNumberWithBreaks(
                            group.subItems[0]?.inward_qty
                          ) || "0"}
                    </div>
                  </td>
                  <td className={styles.textRight}>
                    <div className={styles.numberWrapper}>
                      {hasDifferentBuyItems
                        ? "-"
                        : formatNumberWithBreaks(
                            group.subItems[0]?.shortage_qty
                          ) || "0"}
                    </div>
                  </td>
                  <td className={styles.textRight}>
                    <div className={styles.numberWrapper}>
                      {hasDifferentBuyItems
                        ? "-"
                        : formatNumberWithBreaks(
                            group.subItems[0]?.provision_qty
                          ) || "0"}
                    </div>
                  </td>
                  <td className={styles.cellWrap}>
                    {hasDifferentBuyItems
                      ? "-"
                      : group.subItems[0]?.remarks || "-"}
                  </td>
                </tr>

                {hasDifferentBuyItems &&
                  group.subItems.map((item, subIndex) => (
                    <tr key={item.id} className={styles.subItemRow}>
                      <td
                        className={`${styles.textCenter} ${styles.subItemIndex}`}>
                        {`${index + 1}.${subIndex + 1}`}
                      </td>
                      <td>
                        <div className={styles.subItemCode}>
                          {item.buy_item_code || "N/A"}
                          <div className={styles.subItemDesc}>
                            <span>Product Description:</span>
                            <br />
                            {item.description || "N/A"}
                          </div>
                        </div>
                      </td>
                      <td className={`${styles.textCenter} ${styles.uomCell}`}>
                        {item?.uom || "N/A"}
                      </td>
                      <td className={styles.textRight}>
                        <div className={styles.numberWrapper}>
                          {formatNumberWithBreaks(item?.remaining_qty) || "0"}
                        </div>
                      </td>
                      <td className={styles.textRight}>
                        <div className={styles.numberWrapper}>
                          {formatNumberWithBreaks(item?.inward_qty) || "0"}
                        </div>
                      </td>
                      <td className={styles.textRight}>
                        <div className={styles.numberWrapper}>
                          {formatNumberWithBreaks(item?.shortage_qty) || "0"}
                        </div>
                      </td>
                      <td className={styles.textRight}>
                        <div className={styles.numberWrapper}>
                          {formatNumberWithBreaks(item?.provision_qty) || "0"}
                        </div>
                      </td>
                      <td className={styles.cellWrap}>
                        {item?.remarks || "-"}
                      </td>
                    </tr>
                  ))}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>

      <div className={styles.totalsSectionRight}>
        <table className={styles.totalsTable}>
          <tbody>
            <tr className={styles.grandTotal}>
              <td className={styles.totalLabel}>TOTAL INWARD QTY:</td>
              <td className={styles.totalValue}>
                <div className={styles.scientificNumber}>
                  {totalInwardQty
                    ? formatNumberWithBreaks(totalInwardQty)
                    : "0"}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className={styles.clearFix}></div>
    </div>
  );
};

export default InwardPDF;


